import Logo from "shared/Logo/Logo";
import SocialsList from "shared/SocialsList/SocialsList";
import { CustomLink } from "data/interfaces";
import { Link } from "react-router-dom";
import React from "react";
import { companyDetails } from "data/company_details";
// import ChangeLanguage from "components/ChangeLanguage/ChangeLanguage";

import f1 from "../../images/supporters/f1.png";
import f2 from "../../images/supporters/f2.png";
import logoRegioneToscana from "../../images/supporters/logo-regione-toscana.jpg";
import logoUnlock from "../../images/supporters/logo-unlock.png";
import logoItaliaDomani from "../../images/supporters/italia_domani.png";
import logoMinisteroCultura from "../../images/supporters/ministero_della_cultura.png";
import logoNextGenerationEU from "../../images/supporters/next_generation_eu.png";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "1",
    title: "Azienda",
    menus: [
      { href: "/about", label: "Chi siamo" },
      { href: "/contacts", label: "Contatti" },
      { href: "/become-host", label: "Diventa un host" },
      { href: "/privacy-policy", label: "Privacy Policy" },
      { href: "/terms-and-conditions", label: "Termini e Condizioni" },
    ],
  },
  {
    id: "2",
    title: "Con il supporto economico di",
    menus: [
      { href: "#", image: f1 },
      { href: "#", image: f2 },
      { href: "#", image: logoRegioneToscana },
      { href: "#", image: logoUnlock },
      { href: "#", image: logoItaliaDomani },
      { href: "#", image: logoMinisteroCultura },
      { href: "#", image: logoNextGenerationEU },
    ],
  },
  {
    id: "4",
    title: "Supporto & Press",
    menus: [
      { href: "mailto:help@tribyou.life", label: "help@tribyou.life" },
      { href: "mailto:press@tribyou.life", label: "press@tribyou.life" },
    ],
  },
  {
    id: "6",
    title: "Altri dati",
    menus: [
      { href: `mailto:${companyDetails.mail}`, label: `PEC: ${companyDetails.mail}` },
      { href: "#", label: `Codice univoco: ${companyDetails.unique_code}` },
      { href: "#", label: `Polizza RC: ${companyDetails.insurance_details?.policy_provider}` },
      { href: "#", label: `Polizza N. ${companyDetails.insurance_details?.policy_number}` },
      { href: "#", label: `Scadenza: ${companyDetails.insurance_details?.expiration_date}` },
      { href: "#", label: "Fondo Consortile di Garanzia - Vacanze Garantite" },
      { href: "#", label: "Certificato di garanzia n. 2026032552AT" },
      { href: "#", label: "Tour Operator iscritto all'Elenco degli operatori della Regione Lazio" },
    ],
  },
  {
    id: "8",
    title: "Dati fiscali",
    menus: [
      { href: "#", label: "TRIBYOU è un marchio di HQVILLAGE SB SRL" },
      { href: "#", label: "Sede legale: Via Giordano Bruno 21 - 56025 Pontedera (PI)" },
      { href: "#", label: "Sede operativa: Via Giovanni Andrea Dell'Anguillara 4 - 01015 Sutri (VT)" },
      { href: "#", label: "P.I 02443490509" },
      { href: "#", label: "Capitale sociale I.V. : 65000€" },
    ],
  },
];

const Footer: React.FC = () => {
  const renderMenuItem = (menu: CustomLink) => {
    if (menu.isExternal) {
      return (
        <div className="flex flex-col items-start gap-2">
          <a
            href={menu.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
          >
            {menu.image && <img src={menu.image} alt="Partner logo" className="h-6" />}
          </a>
          {menu.subText && (
            <a
              href={menu.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
            >
              {menu.subText}
            </a>
          )}
        </div>
      );
    }
    
    if (menu.image) {
      return (
        <Link to={menu.href}>
          <img src={menu.image} alt="" />
        </Link>
      );
    }

    if (menu.href.startsWith("/")) {
      return (
        <Link
          className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
          to={menu.href}
        >
          {menu.label}
        </Link>
      );
    }

    return (
      <a
        className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
        href={menu.href}
      >
        {menu.label}
      </a>
    );
  };

  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              {renderMenuItem(item)}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-24 lg:py-28 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-6 lg:gap-x-10 ">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
          <div className="col-span-2 flex items-center md:col-span-3">
            <SocialsList
              className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start"
              itemClass="flex items-center text-2xl text-neutral-700 hover:text-black dark:text-neutral-300 dark:hover:text-white leading-none space-x-2 group"
              showLabel
            />
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
      </div>
      {/* <ChangeLanguage /> */}
    </div>
  );
};

export default Footer;
